<template>
  <solo-card>
    <template slot="title">
      <h3>404</h3>
      <p>{{ $t('PAGE_notfound_marketing') }}</p>
    </template>
    <template slot="default">
      <p>{{ $t('PAGE_notfound_message') }}</p>
      <p>
        {{ $t('PAGE_notfound_backto') }}
        <router-link :to="{ name: 'home' }">rheumafit.ch</router-link>
      </p>
    </template>
  </solo-card>
</template>

<script>
import SoloCard from '@/components/SoloCard';

export default {
  name: 'not-found',
  components: { SoloCard },
};
</script>



// WEBPACK FOOTER //
// src/pages/NotFound.vue